"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modlToJson = void 0;
const modl_parser_1 = require("modl-parser");
const Utils_1 = require("./Utils");
function modlToJson(modl) {
    if (modl.s instanceof Array) {
        if (modl.s.length === 1 && modl.s[0] instanceof modl_parser_1.ModlArray) {
            return arrayToJson(modl.s[0]);
        }
        else {
            const result = {};
            modl.s.forEach((structure) => {
                if (structure instanceof modl_parser_1.ModlPair) {
                    pairToJson(structure, result);
                }
                if (structure instanceof modl_parser_1.ModlMap) {
                    mapToJson(structure, result);
                }
                if (structure instanceof modl_parser_1.ModlArray) {
                    throw new Error('Array cannot be stored directly in a map, it must be a pair');
                }
            });
            return Object.keys(result).length === 0 ? null : result;
        }
    }
    else {
        return toJson(modl.s);
    }
}
exports.modlToJson = modlToJson;
function toJson(x) {
    if (x instanceof modl_parser_1.ModlArray) {
        return arrayToJson(x);
    }
    if (x instanceof modl_parser_1.ModlMap) {
        return mapToJson(x, {});
    }
    if (x instanceof modl_parser_1.ModlPair) {
        return pairToJson(x, {});
    }
    if (x instanceof modl_parser_1.ModlQuoted) {
        return stringEscapeReplacer.replace(unquote(x.value));
    }
    if (x instanceof modl_parser_1.ModlInteger) {
        return x.value;
    }
    if (x instanceof modl_parser_1.ModlFloat) {
        return x.value;
    }
    if (x instanceof modl_parser_1.ModlString) {
        return stringEscapeReplacer.replace(unquote(x.value));
    }
    if (x === modl_parser_1.ModlBoolNull.ModlFalse) {
        return false;
    }
    if (x === modl_parser_1.ModlBoolNull.ModlTrue) {
        return true;
    }
    if (x === modl_parser_1.ModlBoolNull.ModlNull) {
        return null;
    }
    return x;
}
const stringEscapeReplacer = Utils_1.createStringEscapeReplacer();
function pairToJson(p, result) {
    const key = stringEscapeReplacer.replace(p.key instanceof modl_parser_1.ModlQuoted ? unquote(p.key.value) : unquote(p.key));
    result[key] = toJson(p.value);
    return result;
}
function mapToJson(m, result) {
    m.items.forEach((i) => {
        pairToJson(i, result);
    });
    return result;
}
function arrayToJson(a) {
    const result = new Array();
    a.items.forEach((x) => result.push(toJson(x)));
    return result;
}
function unquote(s) {
    return (s.startsWith('`') && s.endsWith('`')) || (s.startsWith('"') && s.endsWith('"'))
        ? s.substring(1, s.length - 1)
        : s;
}
//# sourceMappingURL=ModlToJson.js.map